import { User } from '../types/User';

const SUPER_ADMINS = {
  'b6f352de-bfba-44b5-b92c-879ff8f2aa99': {
    email: 'kevin@oraai.com',
  },
  '971fcbef-c5ec-4bf4-a3a1-c10222c2a7f4': {
    email: 'jacob@oraai.com',
  },
};

export const isSuperAdmin = (
  userOrId: string | User | null | undefined
): boolean => {
  if (!userOrId) return false;

  let userId: string;

  if (typeof userOrId === 'string') {
    userId = userOrId;
  } else {
    userId = userOrId.id;
  }

  return Object.keys(SUPER_ADMINS).includes(userId);
};
